export interface Confirmable {
  pubChannel: string
  pubAs: string
  detail: object
  confirmationTitle: string
  confirmationMessage: string
}

// Represents an operation to be confirmed with the user. This object
// will be passed along with the event that opens the modal. If and when
// the user confirms, the modal will an event with the specified channel,
// name, and detail, which the original controller can then consume and
// run the action.
export class Confirmable {
  declare pubChannel: string
  declare pubAs: string
  declare detail: object
  declare confirmationTitle: string
  declare confirmationMessage: string

  constructor({
    pubChannel,
    pubAs,
    detail,
    confirmationTitle,
    confirmationMessage,
  }) {
    if (!pubChannel) {
      throw (new Error(), 'you must specify a pubChannel')
    }
    if (!pubAs) {
      throw (new Error(), 'you must specify a pubAs')
    }
    if (!confirmationMessage) {
      throw (new Error(), 'you must specify a confirmation message')
    }

    this.pubChannel = pubChannel
    this.pubAs = pubAs
    this.detail = detail
    this.confirmationTitle = confirmationTitle
    this.confirmationMessage = confirmationMessage
  }
}
